package app.nestbridge.app.screen

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object AppScreen : Screen

data class AppState(
    val eventSink: (AppEvent) -> Unit = {},
) : CircuitUiState

sealed interface AppEvent {
    data object OnAppear : AppEvent
}
